import { FormDataInput, FormDataState } from 'types/formPage';

import { composeReducers, createUpdateWithKeyReducer, createDeleteWithKeyReducer } from '../@reducers';

import initialState from './initialState';


const NAME = '@formData';

// reducers
const getReducer = createUpdateWithKeyReducer<FormDataInput>(NAME, initialState);
const deleteReducer = createDeleteWithKeyReducer<FormDataInput>(NAME, initialState);
export const formsDataReducer = composeReducers<FormDataState>(initialState)(getReducer, deleteReducer);

export default formsDataReducer;
